
import EMVERSITY from "@/assets/industry-co-led/partners/EMVERSITY.png";
import Icon1 from "@/assets/industry-co-led/logo/madel.png";
import Icon2 from "@/assets/industry-co-led/logo/network.png";

import Student1 from "@/assets/students/student1.png";
import Student2 from "@/assets/students/student2.png";
import Student3 from "@/assets/students/student3.png";
import Student4 from "@/assets/students/student4.png";

const OJLImg1 = "https://cdn.msu.edu.in/medium_Kabita_b5ccaaab65.webp";
const OJLImg2 = "https://cdn.msu.edu.in/medium_MAMTA_35769bc27b.webp";
const OJLImg3 = "https://cdn.msu.edu.in/medium_Subba_85c9905aca.webp";
const OJLImg4 = "https://cdn.msu.edu.in/medium_Lalita_169d2968af.webp";
const OJLImg5 = "https://cdn.msu.edu.in/medium_deepansa_9caf57d963.webp";
const OJLImg6 = "https://cdn.msu.edu.in/medium_Bishnu_d768147532.webp";

const Img1 = "https://cdn.msu.edu.in/EMT_2_c52c8e4934.png";
const Img2 = "https://cdn.msu.edu.in/EMT_4_3d66f2cd55.png";
const Img3 = "https://cdn.msu.edu.in/b_sc_in_emergency_medical_technology_65089a01f5.webp";
const Img4 = "https://cdn.msu.edu.in/art_1_ed655481a8.webp";
const Img5 = "https://img.youtube.com/vi/lTWke3-IGz4/hqdefault.jpg";

export const medicalLaboratoryScience = {
  heroSection: {
    breadcrumb: [
      { name: "Home", url: "/" },
      {
        name: "Industry Co-led UG Programmes",
        url: "/industry-co-led-ug-programmes",
      },
      { name: "Bachelor of Medical Laboratory Science", url: "" },
    ],
    bannerImg: "https://img.youtube.com/vi/lTWke3-IGz4/hqdefault.jpg",
    title: "Bachelor of Medical Laboratory Science",
    poweredBy: {
      text: "Industry Skilling Partner",
      logo: EMVERSITY,
    },
    duration: "4 Year Undergraduate Degree Programme",
    description:
      "Learn about Clinical Biochemistry, Hematology, Microbiology, Histopathology, Immunology, Molecular Diagnostics, Lab Instrumentation, Quality Assurance, and more in the healthcare diagnostics sector.",
    stats: [
      {
        value: "Up to 70%",
        label: "Hands-on training",
      },
      {
        value: "Paid",
        label: "On-the-job learning",
      },
      {
        value: "100%",
        label: "Placement Assistance",
      },
    ],
    buttons: {
      download: "Download Brochure",
      enroll: "Enroll Now",
    },
    video: {
      thumbnail: "https://img.youtube.com/vi/vg__LuHdK60/hqdefault.jpg",
      buttonText: "Watch Programme Video",
      url: "https://www.youtube.com/embed/vg__LuHdK60",
    },

  },

  aboutSection: {
    tag: "ABOUT THE PROGRAMME",
    title: "A Degree Built for Advanced Diagnostic & Laboratory Practice",
    description: [
      "The Bachelor of Medical Laboratory Science prepares students to play a critical role in disease detection, diagnosis, and clinical decision-making through laboratory science. The program builds strong biomedical foundations alongside intensive training in haematology, microbiology, histopathology, immunology and molecular diagnostics.",
      "Through hands-on laboratory work, simulation-based learning, and structured clinical internships in hospital and diagnostic lab settings, students develop the technical precision and analytical skills required in modern diagnostic environments. Graduates are equipped to support accurate, timely and reliable medical diagnosis across healthcare systems.",
    ],
    stats: [
      { value: "Up to 70%", label: "Hands-on training" },
      { value: "Paid", label: "Paid on-the-job learning" },
      { value: "100%", label: "Placement Assistance" },
    ],
    approvals: [
      "UGC Approved",
      "NEP 2020 Aligned",
      "Govt. Scholarships Available",
    ],
    journeyTitle: "Your 4-Year Journey",
    journey: [
      {
        phase: "YEAR 1",
        title: "Biomedical Foundations",
        description:
          "Human anatomy, physiology, biochemistry, microbiology, and basic laboratory techniques",
      },
      {
        phase: "YEAR 2",
        title: "Core Laboratory Sciences",
        description:
          "Pathology, clinical biochemistry, haematology, microbiology, immunology, and lab instrumentation",
      },
      {
        phase: "YEAR 3",
        title: "Advanced Diagnostics & Specialisations",
        description:
          "Molecular diagnostics, advanced histopathology, transfusion medicine, quality assurance, and clinical rotations",
      },
      {
        phase: "YEAR 4",
        title: "Clinical Practice & Professional Readiness",
        description:
          "Lab management, accreditation standards, hospital internships, research project, and emerging diagnostic technologies",
      },
      {
        phase: "GRADUATE",
        title: "Bachelor of Medical Laboratory Science",
        description: "Industry-ready diagnostic and laboratory science professional",
      },
    ],
  },

  offeringSection: {
    tag: "OUR OFFERING",
    title: {
      first: "Comprehensive",
      highlight: "Diagnostic & Laboratory Science Education",
    },
    description:
      "We offer a UGC-recognised, full-time undergraduate degree, Bachelor of Medical Laboratory Science at Medhavi Skills University, Sikkim. It is an industry-aligned allied healthcare program designed to build strong laboratory competencies and prepare students for high-impact roles in clinical diagnostics and disease detection.",
    learningBox: {
      title: "Key Areas of Learning",
      points: [
        "Human Physiology",
        "Fundamentals of Microbiology",
        "Clinical Haematology",
        "Genetics and Molecular Biology",
        "Analytical Biochemistry",
        "Biostatistics and Research Methodology"
      ],
    },
    image: "https://cdn.msu.edu.in/MLT_Program_overview_2_01701b7fc7.jpg",
  },

  whyEMT: {
    tag: "WHY MEDICAL LABORATORY SCIENCE. WHY NOW.",
    title: "The Foundation of Evidence-Based Medicine",
    description:
      "Our curriculum responds to the massive expansion of India's diagnostic infrastructure. As healthcare moves from symptomatic to data-driven treatment, the Medical Laboratory Scientist has become the indispensable navigator of the clinical decision-making process.",
    stats: [
      {
        value: "₹1.1 Lakh Crore",
        text: "Valuation of India's Diagnostic Market. Growing at a double-digit CAGR, the sector is shifting toward Tier-2 and Tier-3 cities. This expansion creates a high-stakes demand for scientists who can manage advanced automated labs beyond metropolitan hubs.",
      },
      {
        value: "300,000+",
        text: "Labs operating across India. With the sector rapidly consolidating, large hospital chains and national networks are aggressively hiring degree-holding experts to standardize quality and replace traditional diploma-level roles.",
      },
      {
        value: "15%",
        text: "Reimbursement Premium for Accredited Labs. Government mandates now prioritize NABL-accredited facilities. Professionals trained in ISO standards and molecular diagnostics have become the most sought-after assets in the modern laboratory workforce.",
      },
    ],
  },

  msuAdvantages: {
    tag: "MSU ADVANTAGES",
    title: "Programme by Emversity, Delivered at MSU Campus",
    description:
      "Where academic excellence meets the operational demands of the modern allied and healthcare industry.",
    cards: [
      {
        number: "01",
        text: "Only university in Sikkim aligned with paid On-the-Job Learning embedded curriculum for practical learning",
      },
      {
        number: "02",
        text: "Only university in Sikkim to ensure 100% of our student applicants receive government scholarships",
      },
      {
        number: "03",
        text: "Well-equipped simulation labs, advanced training setups and hands-on field training",
      },
    ],
    pointerTitle: "Highlights from The Programme:",
    highlights: [
      "Programme aligned with NEP2020, focused in Learning Outcome Based Education",
      "Up to 70% practical based curriculum",
      "Paid On-the-job Learning",
      "Industry-aligned curriculum & hands-on learning",
      "Learn from seasoned professionals",
      "Immersive industry exposure through industry visits, guest lectures and networking opportunities",
      "Chance to 'learn and earn' through immersive on-the-job learning, industry projects and internships with leading companies",
      "Engage with industry experts to get invaluable insights and real-world perspectives",
    ],
    image: "https://cdn.msu.edu.in/advantages_bc70522750.webp",
  },

  CTA: {
    title: "Start Your Journey in Clinical Diagnostics with Emversity's",
    highlights: "Bachelor of Medical Laboratory Science",
    url: "#",
    btnName: "Apply Now",
  },

  onJobtrainningData: {
    tag: "ON-THE-JOB LEARNING",
    title: "Practical Industry Exposure",
    description:
      "Our On-the-job Learning (OJL) enables students to gain real industry experience and earn a stipend while you gain your degree.",
    images: [
      { id: 1, src: OJLImg1, alt: "Lab student working at diagnostic equipment" },
      { id: 2, src: OJLImg2, alt: "Student conducting sample analysis" },
      { id: 3, src: OJLImg3, alt: "Student at clinical laboratory" },
      { id: 4, src: OJLImg4, alt: "Student operating automated analyser" },
      { id: 5, src: OJLImg5, alt: "Student working on PCR techniques" },
      { id: 6, src: OJLImg6, alt: "Student in pathology lab" },
    ],
  },

  addtionSkill: {
    courseSections: {
      AdditionalSkills: {
        tag: "BONUS CREDENTIALS",
        title: "Additional Skill Development",
        description:
          "Students will have the opportunity to build additional skills that set them apart in the competitive healthcare diagnostics market. These credentials, earned alongside your degree, validate your technical expertise, strengthen laboratory competence, and ensure readiness for employment with leading national and international healthcare organisations.",
        image: {
          url: "https://cdn.msu.edu.in/small_ADP_7679_1_d2fcb8db2d.jpg",
          alternativeText: "Skill Certification",
        },
        items: [
          {
            id: 1,
            text: "Cambridge English for Healthcare Professionals as per CEFR Standards",
            icon: Icon1,
          },
          {
            id: 2,
            text: "Advanced Laboratory & Diagnostic Skills Training (Automation, Molecular Techniques, Quality Systems)",
            icon: Icon2,
          },
          { id: 3, text: "Nationally & Globally Recognised", icon: Icon1 },
        ],
        button: { text: "Apply Now", link: "/apply" },
      },
    },
  },

  DoExperienceLearndata: {
    tag: "INFRASTRUCTURE",
    title: "Do-Experience-Learn",
    description:
      "Discover the advantage of MSU's cutting-edge infrastructure, featuring modern laboratories, classrooms and industry-relevant facilities",
    images: [
      { id: 1, src: Img1, size: "large", alt: "Classrooms" },
      { id: 2, src: Img2, size: "large", alt: "Medical Laboratory Labs" },
      { id: 3, src: Img3, size: "small", alt: "Diagnostic Equipment" },
      { id: 4, src: Img4, size: "small", alt: "Lab Instrumentation" },
      { id: 5, src: Img5, size: "small", alt: "Virtual Campus Tour" },
    ],
  },

  studentStoriesData: {
    title: "Medhavians Speak",
    subText: "Real journeys of action and achievement.",
    students: [
      {
        name: "Radhika Chettri",
        image: Student2,
        videLink:
          "https://cdn.msu.edu.in/Student-Testimonials/Allied-Healthcare-Long.mp4",
        shortUrl:
          "https://cdn.msu.edu.in/Student-Testimonials/Allied-Healthcare-short.mp4",
      },
      {
        name: "Pratik Chettri",
        image: Student3,
        videLink:
          "https://cdn.msu.edu.in/Student-Testimonials/Computer-Science-Long.mp4",
        shortUrl:
          "https://cdn.msu.edu.in/Student-Testimonials/Computer-Science+-short.mp4",
      },
      {
        name: "Suhana Sharma",
        image: Student4,
        videLink:
          "https://cdn.msu.edu.in/Student-Testimonials/Pharmacy-Long.mp4",
        shortUrl:
          "https://cdn.msu.edu.in/Student-Testimonials/Pharmacy-short.mp4",
      },
      {
        name: "Hissey Bhutia",
        image: Student1,
        videLink:
          "https://cdn.msu.edu.in/Student-Testimonials/Nursing-Long.mp4",
        shortUrl:
          "https://cdn.msu.edu.in/Student-Testimonials/Nursing-short.mp4",
      },
    ],
  },

  eligibility: {
    tag: "ELIGIBILITY",
    title: "Who Can Apply?",
    description:
      "10+2 (Any Stream) with 50% Aggregate with Physics, Chemistry and Biology/Mathematics as core subjects",
    button: { text: "Apply Now", url: "" },
    items: [
      {
        title: "12th Pass - Science Stream",
        text: "Candidates who have passed 10+2 with Physics, Chemistry and Biology/Mathematics as core subjects are eligible to apply for the Bachelor of Medical Laboratory Science programme.",
      },
    ],
  },

  careerProspects: {
    tag: "CAREER PROSPECTS",
    heading: "Career Prospects",
    description:
      "The Bachelor of Medical Laboratory Science opens doors to essential diagnostic and clinical laboratory roles across hospitals, diagnostic chains, research labs, and public health systems.",
    roles: [
      "Medical Laboratory Technologist",
      "Clinical Biochemistry Technologist",
      "Hematology & Blood Banking Technician",
      "Microbiology Laboratory Technologist",
      "Histopathology & Cytology Technician",
      "Molecular Diagnostics Technologist",
      "Quality Assurance & Lab Compliance Executive (NABL Standards)",
      "Diagnostic Laboratory Operations Specialist",
    ],
  },

  curriculumStructure: {
    label: "WHAT YOU WILL LEARN",
    heading: "Curriculum Structure",
    description:
      "The curriculum blends strong biomedical foundations with intensive laboratory training and industry-integrated modules, ensuring students gain real-world diagnostic experience throughout their degree.",
    semesters: [
      {
        name: "Semester 1",
        title: "Building Foundations in Medical Laboratory Sciences and Healthcare Practice",
        description: "The first semester introduces students to the fundamental scientific and professional concepts that form the basis of medical laboratory sciences. Learners develop a strong understanding of human anatomy and physiology while gaining insights into healthcare systems, laboratory practices, and emergency care principles. The curriculum also emphasizes communication, professionalism, and digital literacy, enabling students to build the knowledge, skills, and professional attitudes required for accurate laboratory work and effective participation in healthcare teams. Practical training further strengthens students' understanding of human body systems and their relevance to diagnostic sciences.",
        subjects: [
          { name: "Human Anatomy", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
          { name: "Human Physiology", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
          { name: "Fundamentals of the Healthcare System and Medical Laboratory Sciences (MLS)", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
          { name: "Communication and Professionalism", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" },
          { name: "Basic Emergency Care and First Aid", bgColor: "bg-[#FFD5D5]", textColor: "text-[#CC0000]" },
          { name: "Basics of Computer Application", bgColor: "bg-[#D5F0FF]", textColor: "text-[#006699]" },
          { name: "Human Anatomy Practical", bgColor: "bg-[#FFF3CC]", textColor: "text-[#996600]" },
          { name: "Human Physiology Practical", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" }
        ]
      },
      {
        name: "Semester 2",
        title: "Developing Core Competencies in Diagnostic Laboratory Sciences",
        description: "The second semester focuses on the fundamental disciplines that support disease diagnosis, laboratory investigations, and public health practices. Students gain an understanding of microbiology, biochemistry, and haematology, enabling them to explore the biological and pathological processes that influence human health. The curriculum also introduces preventive and social medicine, helping learners appreciate the role of healthcare systems in disease prevention and community well-being. Through extensive practical training, students develop the technical skills and laboratory proficiency required for accurate testing, analysis, and diagnostic support services.",
        subjects: [
          { name: "Fundamentals of Microbiology", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
          { name: "Basics of Biochemistry", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
          { name: "Fundamentals of Haematology", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
          { name: "Preventive and Social Medicine", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" },
          { name: "Fundamentals of Microbiology Practical", bgColor: "bg-[#FFD5D5]", textColor: "text-[#CC0000]" },
          { name: "Basics of Biochemistry Practical", bgColor: "bg-[#D5F0FF]", textColor: "text-[#006699]" },
          { name: "Fundamentals of Haematology Practical", bgColor: "bg-[#FFF3CC]", textColor: "text-[#996600]" }
        ]
      },
      {
        name: "Semester 3",
        title: "Advancing Diagnostic Expertise in Clinical Laboratory Sciences",
        description: "The third semester deepens students' understanding of laboratory diagnostics through specialized study of bacteriology, clinical haematology, endocrinology, and metabolic processes. Learners gain insights into the identification of microorganisms, blood-related disorders, hormonal regulation, and biochemical pathways that influence human health. The curriculum also introduces foundational pharmacology concepts, helping students understand the relationship between laboratory findings and therapeutic interventions. Through extensive practical training, students strengthen their analytical abilities, technical precision, and diagnostic competencies required for modern medical laboratory practice.",
        subjects: [
          { name: "Bacteriology", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
          { name: "Intermediary Metabolism and Endocrinology", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
          { name: "Clinical Haematology", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
          { name: "Basics of Pharmacology", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" },
          { name: "Bacteriology Practical", bgColor: "bg-[#FFD5D5]", textColor: "text-[#CC0000]" },
          { name: "Intermediary Metabolism and Endocrinology Practical", bgColor: "bg-[#D5F0FF]", textColor: "text-[#006699]" },
          { name: "Clinical Haematology Practical", bgColor: "bg-[#FFF3CC]", textColor: "text-[#996600]" }
        ]
      },
      {
        name: "Semester 4",
        title: "Mastering Advanced Diagnostic Techniques and Laboratory Quality Systems",
        description: "The fourth semester focuses on advanced areas of medical laboratory sciences that are essential for modern disease diagnosis and healthcare delivery. Students develop an understanding of virology, immunology, genetics, molecular biology, and clinical pathology, enabling them to explore the mechanisms of disease at both cellular and molecular levels. The curriculum also introduces laboratory management and quality control practices, helping learners understand the importance of accuracy, reliability, and regulatory compliance in diagnostic services. Through practical training, students strengthen their technical expertise and laboratory problem-solving skills in specialized diagnostic settings.",
        subjects: [
          { name: "Virology and Immunology", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
          { name: "Genetics and Molecular Biology", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
          { name: "Clinical Pathology", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
          { name: "Medical Laboratory Management and Quality Control", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" },
          { name: "Virology and Immunology Practical", bgColor: "bg-[#FFD5D5]", textColor: "text-[#CC0000]" },
          { name: "Genetics and Molecular Biology Practical", bgColor: "bg-[#D5F0FF]", textColor: "text-[#006699]" },
          { name: "Clinical Pathology Practical", bgColor: "bg-[#FFF3CC]", textColor: "text-[#996600]" }
        ]
      },
      {
        name: "Semester 5",
        title: "Specializing in Advanced Laboratory Diagnostics and Transfusion Sciences",
        description: "The fifth semester focuses on specialized areas of laboratory medicine that support the diagnosis and management of infectious, metabolic, and hematological disorders. Students gain in-depth knowledge of mycology, parasitology, analytical biochemistry, and immunohematology, enabling them to perform and interpret complex laboratory investigations. The curriculum also explores transfusion medicine and medical ethics, helping learners understand the clinical, legal, and professional responsibilities associated with laboratory practice. Through advanced practical training, students develop the technical expertise and diagnostic precision required for specialized laboratory and healthcare settings.",
        subjects: [
          { name: "Mycology & Parasitology", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
          { name: "Analytical Biochemistry", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
          { name: "Immunohematology and Transfusion Medicine", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
          { name: "Medical Law and Ethics", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" },
          { name: "Mycology & Parasitology Practical", bgColor: "bg-[#FFD5D5]", textColor: "text-[#CC0000]" },
          { name: "Analytical Biochemistry Practical", bgColor: "bg-[#D5F0FF]", textColor: "text-[#006699]" },
          { name: "Immunohematology and Transfusion Medicine Practical", bgColor: "bg-[#FFF3CC]", textColor: "text-[#996600]" }
        ]
      },
      {
        name: "Semester 6",
        title: "Integrating Advanced Pathology and Research in Diagnostic Sciences",
        description: "The sixth semester focuses on advanced diagnostic disciplines that enhance students' understanding of disease mechanisms, laboratory investigations, and evidence-based healthcare practices. Learners explore applied pathobiology, cytology, histopathology, and clinical biochemistry, gaining insights into cellular changes, tissue pathology, and biochemical abnormalities associated with various diseases. The curriculum also introduces biostatistics and research methodology, enabling students to develop analytical skills and an evidence-based approach to laboratory practice. Through specialized practical training, students strengthen their diagnostic accuracy and readiness for advanced roles in medical laboratory sciences.",
        subjects: [
          { name: "Applied Pathobiology", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" },
          { name: "Cytology and Histopathology", bgColor: "bg-[#FFE5CC]", textColor: "text-[#CC6600]" },
          { name: "Clinical Biochemistry", bgColor: "bg-[#D4F4DD]", textColor: "text-[#006B3D]" },
          { name: "Biostatistics and Research Methodology", bgColor: "bg-[#E8D5FF]", textColor: "text-[#6B00CC]" },
          { name: "Cytology and Histopathology Practical", bgColor: "bg-[#FFD5D5]", textColor: "text-[#CC0000]" },
          { name: "Clinical Biochemistry Practical", bgColor: "bg-[#D5F0FF]", textColor: "text-[#006699]" },
          { name: "Applied Pathobiology Practical", bgColor: "bg-[#FFF3CC]", textColor: "text-[#996600]" }
        ]
      },
      {
        name: "Semester 7",
        title: "Applying Diagnostic Expertise in Professional Laboratory Settings",
        description: "The internship phase provides students with extensive hands-on exposure to clinical laboratory operations, diagnostic procedures, and research-based learning. Through structured laboratory postings, learners apply their knowledge across disciplines such as microbiology, biochemistry, hematology, pathology, and transfusion medicine while working in real-world healthcare environments. The research dissertation component encourages critical inquiry, analytical thinking, and evidence-based problem-solving, enabling students to strengthen both their technical competence and scientific understanding. This experience prepares graduates for professional roles in diagnostic laboratories, healthcare institutions, and research settings.",
        subjects: [
          { name: "Internship (Clinical Lab Posting / Research Dissertation)", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" }
        ]
      },
      {
        name: "Semester 8",
        title: "Transitioning from Laboratory Learning to Professional Diagnostic Practice",
        description: "The internship phase enables students to gain comprehensive exposure to clinical laboratory operations, diagnostic workflows, and research-driven healthcare environments. Through hands-on participation in laboratory procedures, sample processing, quality assurance practices, and interdisciplinary collaboration, learners apply the knowledge and technical skills acquired throughout the programme. The research dissertation component further strengthens analytical thinking, scientific inquiry, and evidence-based problem-solving. This experiential learning phase helps students build professional confidence and prepares them for successful careers in diagnostic laboratories, healthcare institutions, and research settings.",
        subjects: [
          { name: "Internship (Clinical Lab Posting / Research Dissertation)", bgColor: "bg-[#C8E6FF]", textColor: "text-[#0475B3]" }
        ]
      },
      {
        name: "Value Addition",
        title: "Value-Added Learning Opportunities",
        description: "Students gain access to skill certifications, semester-wise workshops, and industry visits that enhance practical learning and professional development. Additionally, aspiring entrepreneurs can explore venture creation opportunities with mentorship, incubation support, and access to funding through the Medhavi NextGen Innovation and Incubation Center and government-backed initiatives.",
        "keySubjectsLabel": "Key Features",
        subjects: [
          { "name": "Skill certifications", "bgColor": "bg-[#C8E6FF]", "textColor": "text-[#0475B3]" },
          { "name": "One workshop per semester", "bgColor": "bg-[#FFE5CC]", "textColor": "text-[#CC6600]" },
          { "name": "One industry visit per semester", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" },
          { "name": "Opportunity for venture creation through university and government funding (Medhavi NextGen Innovation and Incubation Center)", "bgColor": "bg-[#D4F4DD]", "textColor": "text-[#006B3D]" }
        ],
        "learningOutcomes": [
          "Gain real-world experience through the Red.Health Network internship",
          "Execute industry-based projects in healthcare settings",
          "Complete a capstone project and dissertation",
          "Transition confidently into healthcare management roles",
          "Prepare professionally through CV launch and career readiness activities"
        ]
      }
    ],
  },

  faq: {
    id: 104,
    title: "Bachelor of Medical Laboratory Science",
    FAQ: [
      {
        id: 1,
        Question: "What is the university's role and what is Emversity's role?",
        Answer:
          "MSU manages all academic matters — admissions, examinations, marksheets, transcripts, and degree conferral. All fees are payable directly to the university. Emversity is the industry-skilling partner and delivers AR/VR simulation training, industry-co-designed skill modules, clinical internship facilitation, placement assistance, and the Cambridge English program. Emversity does not collect fees, conduct exams, or award degrees.",
      },
      {
        id: 2,
        Question: "Is placement or internship stipend guaranteed?",
        Answer:
          "Emversity provides placement assistance through its network of 500+ healthcare employer partners and facilitates structured clinical internships. However, placement is not guaranteed and stipend amounts vary by employer. Final hiring and stipend decisions rest with the host institution.",
      },
      {
        id: 3,
        Question: "Is this program recognised, and is it full-time?",
        Answer:
          "Yes, this is a full-time, on-campus program. MSU is established under the Medhavi Skills University, Sikkim Act, 2021 and is recognised by the UGC under Section 2(f). The curriculum is aligned with the NCAHP Act 2021 framework. Students should verify current NCAHP notifications and state council registration requirements directly with the university.",
      },
      {
        id: 4,
        Question: "How do I apply?",
        Answer:
          "Applications are submitted through MSU's official admissions portal. Candidates may be required to appear for the Medhavi Scholarship & Aptitude Test (MSAT). For eligibility verification, fee details, and application deadlines, please contact the MSU admissions office directly.",
      },
      {
        id: 5,
        Question: "What is the Head Start Programme?",
        Answer:
          "The Head Start Programme is a zero-cost, online bridge course offered before classes begin. It covers foundational concepts and essential skills for your chosen field. Participation is voluntary, non-credit-bearing, and does not affect admission status or academic standing. Students who successfully complete it receive a complimentary laptop and may be eligible for additional scholarships.",
      },
      {
        id: 6,
        Question: "Is this programme NCAHP aligned?",
        Answer:
          "Yes. The curriculum is subject to periodic revision by MSU in alignment with NCAHP guidelines and evolving industry requirements. Students should refer to the university's official academic notifications for the latest syllabus.",
      },
    ],
  },

  coursePrice: { price: "₹8,00,000" },
};